import React, { useCallback, useRef } from "react"
import { Button, Input, Typography, Flex } from "antd"
import { SendOutlined, RobotOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import useDashChat from "../../hooks/useDashChat"
import ChatMessage from "../ChatMessage/ChatMessage"
import styles from "../../style.module.css"

const { Text } = Typography

export default function DashChatWidget() {
  const { t } = useTranslation()
  const chatBodyRef = useRef(null)

  const scrollToBottom = useCallback(() => {
    if (chatBodyRef.current) chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight
  }, [])

  const {
    input, setInput,
    messages,
    isLoading,
    handleSend,
    handleChartDismiss,
    handleChartOptionSelect,
    handleOptionSelect,
  } = useDashChat(scrollToBottom)

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSend() }
  }

  return (
    <div className={styles.dashChat}>
      <Flex align="center" gap={12} className={styles.dashChatHeader}>
        <div className={styles.dashAvatar}>
          <RobotOutlined className={styles.chatAvatarIcon} />
        </div>
        <div>
          <Text strong className={styles.dashName}>{t("ai_dashboard.dash_name")}</Text>
          <Text type="secondary" className={styles.textSm}>{t("ai_dashboard.dash_subtitle")}</Text>
        </div>
      </Flex>

      <div className={styles.dashChatBody} ref={chatBodyRef}>
        {messages.map((message) => (
          <ChatMessage
            key={message.id}
            message={message}
            onChartDismiss={handleChartDismiss}
            onChartOptionSelect={handleChartOptionSelect}
            onOptionSelect={handleOptionSelect}
          />
        ))}
        {isLoading && (
          <div className={styles.chatMsg}>
            <div className={styles.dashAvatarSm}>
              <RobotOutlined className={styles.chatAvatarIconSm} />
            </div>
            <div className={`${styles.chatBubble} ${styles.chatBubbleAi}`}>
              <Text type="secondary" className={styles.textSm}>{t("ai_dashboard.thinking")}</Text>
            </div>
          </div>
        )}
      </div>

      <Flex align="center" gap={8} className={styles.dashChatInput}>
        <Input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={t("ai_dashboard.input_placeholder")}
          variant="borderless"
          className={styles.chatInputField}
          disabled={isLoading}
        />
        <Button type="primary" icon={<SendOutlined />} shape="round" loading={isLoading} onClick={handleSend}>
          <span className={styles.chatSendLabel}>{t("ai_dashboard.send")}</span>
        </Button>
      </Flex>
    </div>
  )
}

DashChatWidget.propTypes = {}
